// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__3FF6w","inputWrapper":"Checkbox_inputWrapper__26aOe","errorText":"Checkbox_errorText__3aabi"};